// extracted by mini-css-extract-plugin
export var header = "Header-module--header--3VlH4";
export var skipLink = "Header-module--skipLink--362QN";
export var logoHome = "Header-module--logoHome--3TSQF";
export var svgLight = "Header-module--svgLight--fm4tC";
export var fixedContent = "Header-module--fixedContent--2pnph";